import {createApi} from '@reduxjs/toolkit/query/react'
import {fetchBaseFPNetQuery} from "@commons/utils/fetchBaseFPNetQuery";
import {ElementiRML, getTagsList} from "@commons/mapping/DataTablesSchema";
import {addBaseQueryParams, addURI, BaseQueryParams, transformResponse} from "@commons/utils/APIParams";
import {ElementoRMLRecord} from "@commons/mapping/ElementoRMLRecord";
import {config} from "@commons/config.instance";

export const elementiRMLApi = createApi({
    reducerPath: 'elementiRMLApi',
    baseQuery: fetchBaseFPNetQuery({baseUrl: config.getBaseUrl('HR') + '/sistema/elementi-RML'}),
    tagTypes: ['Elementi'],
    endpoints: (builder) => ({
        getElementiFlat: builder.query<ElementoRMLRecord[], Partial<BaseQueryParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                return `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            }
        }),

        getElementi: builder.query<ElementiRML, Partial<BaseQueryParams>>({
            query: (filter) => {
                let params: string[] = addBaseQueryParams(filter);
                return `${params.length > 0 ? '?' + encodeURI(params.join("&")) : ''}`;
            },
            transformResponse,
            providesTags: (result) => getTagsList<ElementoRMLRecord>(result, 'Elementi'),
        }),

        getElemento: builder.query<ElementoRMLRecord, string | undefined>({
            query: (URI) => {
                // https://stackoverflow.com/questions/69568818/how-to-dynamically-change-base-url-using-redux-toolkit
                // If you pass in a full url (starting with http:// or https://) fetchBaseQuery will skip baseUrl and use the supplied url instead.
                return URI ? URI : `/${URI}`;
            },
            transformResponse: addURI
        }),

        deleteElemento: builder.mutation<void, string>({
            query: (URI) => ({
                url: URI ? URI : '',
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'Elementi', id: 'LIST'}],
        }),

        updateElemento: builder.mutation<Partial<ElementoRMLRecord>, Partial<ElementoRMLRecord> & Pick<ElementoRMLRecord, 'URI'>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: ({URI, ...patch}) => ({
                url: URI ? URI : '',
                method: 'PUT', // 'PATCH'
                body: patch,
            }),
            transformResponse,
            invalidatesTags: (result, error, {URI}) => [{type: 'Elementi', URI}],
        }),

        insertElemento: builder.mutation<Partial<ElementoRMLRecord>, Partial<ElementoRMLRecord>>({
            // note: an optional `queryFn` may be used in place of `query`
            query: (payload) => ({
                url: '',
                method: 'POST',
                body: payload,
            }),
            transformResponse,
            invalidatesTags: [{type: 'Elementi', id: 'LIST'}],
        }),
    }),
})
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetElementiFlatQuery,
    useGetElementiQuery,
    useGetElementoQuery,
    useLazyGetElementoQuery,
    useUpdateElementoMutation,
    useInsertElementoMutation,
    useDeleteElementoMutation
} = elementiRMLApi;